import Vue from 'vue'
import Vuex from 'vuex'
import permission from './modules/permission'
Vue.use(Vuex)

const access_token = 'admin-token'

export default new Vuex.Store({
  modules: {
    permission
  },
  state: {
    token: localStorage.getItem(access_token) || '',
    routes: [] ,// 动态路由
    menuList:[],
    userRoles:[],
    userPermissions:[],
    userInfo:{}
  },
  mutations: {
    setToken(state, token) {
      state.token = token
      localStorage.setItem(access_token, token)
    },
    clearToken(state) {
      state.token = ''
      localStorage.removeItem(access_token)
    },
    //清空vuex里面所有内容
    clearVuex(state) {
        state.userInfo = {};
        state.userPermissions = [];
        state.userRoles = [];
    },
    setRoutes(state, routes) {
      state.routes = routes
    },
    //设置muneList
    setMenulist(state, list) {
        state.menuList = list;
    },
    //设置用户信息
    setUserInfo(state, obj) {
        state.userInfo = obj;
    },
    //设置按钮权限信息
    setUserPermissions(state, list) {
        state.userPermissions = list;
    },
    //设置角色信息
    setUserRoles(state, list) {
        state.userRoles = list;
    },
    // //生成动态路由
    // dynamicRouter(state, router) {
    //     //获取原来的路由

    //     let oldRouter = [];
    //     let menuList = state.menuList;

    //     //递归将路由数据写入到路由表中
    //     addRouter(menuList);
    //     for (let x of oldRouter) {
    //         router.addRoute('home', x)
    //     }

    //     //递归方法
    //     function addRouter(menuList) {
    //         if (Array.isArray(menuList) && menuList.length > 0) {
    //             menuList.forEach(item => {
    //                 if (item.children.length == 0) {
    //                     item.component = resolve => require([`@/views${item.path}.vue`], resolve);
    //                     item.meta = { title: item.label };
    //                     delete item.name;
    //                     oldRouter.push(item);
    //                 }
    //                 addRouter(item.children);
    //             });
    //         }
    //     }
    // },
  },
  actions: {
    login({ commit }, payload) {
      const fakeToken = 'fake-admin-token'
      commit('setToken', fakeToken)
      return Promise.resolve()
    },
    logout({ commit }) {
      commit('clearToken')
      commit('setRoutes', [])
    },
    // setRoutes({ commit }, routes) {
    //   commit('setRoutes', routes)
    // }
    setRoutes({ commit }, router) {
      commit('dynamicRouter', router)
    },
    //退出时执行清空所有vuex里面的内容
    clearAllVuex({ commit }) {
        commit('clearVuex');
    }
  },
  getters: {
    isAuthenticated: state => !!state.token,
    routes: state => state.routes
  }
})